






















import { Component, Vue, Prop } from 'vue-property-decorator';
import avatar_initials from '../utils/avatar-initials';
import { User } from '../interfaces/models/user';

@Component
export default class AssignUserToSlide extends Vue {
  @Prop({ type: Array }) assignedTo?: User.BaseInfos[];

  get noAssignee() {
    return this.assignedTo && this.assignedTo.length === 0;
  }
}
